import { isNumber } from "../utils/utils"
import { DropDownMenu } from "./dropdown"


type View =
    {
        id: string | number
        disabled?: boolean
    }
    & (
        | {
            text: React.ReactNode
            icon?: string
            content?: never
        }
        | {
            /** This can be used to override the content of the button */
            content: React.FunctionComponent<{ view: View, disabled: boolean, buttonStyle: React.CSSProperties }>
            text?: never
            icon?: never
        }
    )

interface Props {

    views: Readonly<View[]>

    view: string | number
    setView(view: string | number): void

    left?: number
    buttonWidth?: number
    disabled?: boolean
    minWidth?: number

}

export function ViewSelect({ views, view, setView, buttonWidth, disabled, minWidth, left }: Props) {

    const [state, setState] = React.useState({
        collapsed: false,
    })

    views = views || []
    minWidth = isNumber(minWidth) ? minWidth : 1300

    const viewObj = views.find(f => f.id == view)

    const { collapsed } = state

    const shouldCollapse = () => {
        const windowWidth = window.innerWidth
        return minWidth && windowWidth && (windowWidth < minWidth)
    }

    const handleResize = () => {

        const b = collapsed
        const a = shouldCollapse()

        if (a != b) {
            setState(s => ({ ...s, collapsed: a }))
        }

    }

    const setViewIfEnabled = (id: string | number) => {
        if (!disabled) {
            setView(id)
        }
    }

    React.useEffect(() => {

        window.addEventListener("resize", handleResize)

        handleResize()

        return () => {
            window.removeEventListener("resize", handleResize)
        }

    })

    const style = left ? { left: left + "px" } : undefined
    const buttonStyle = buttonWidth ? { minWidth: buttonWidth + "px" } : undefined


    return <div className="omnia-view-select" style={style}>

        {
            (!collapsed) &&
            <div>

                {
                    views.map(v => {

                        const Content = v.content

                        if (Content) {
                            return <Content
                                key={v.id}
                                view={v}
                                disabled={disabled || v.disabled}
                                buttonStyle={buttonStyle}
                            />
                        }

                        return <button
                            key={v.id}
                            type="button"
                            disabled={disabled || v.disabled}
                            style={buttonStyle}
                            className={`btn btn-default ${v.id == view ? "active" : ""}`}
                            onClick={() => setViewIfEnabled(v.id)}>
                            {v.icon && <i className={v.icon} style={{ marginRight: 5 }} />}
                            {v.text}
                        </button>

                    })

                }

            </div>
        }

        {
            collapsed &&

            <DropDownMenu
                dropdownClass="omnia-header-dropdown left"
                button={
                    <button type="button" className="btn btn-default active dropdown" style={buttonStyle} disabled={disabled}>
                        {viewObj?.icon && <i className={viewObj.icon} style={{ marginRight: 5 }} />}
                        {viewObj?.text}
                        {" "}
                        <span className="caret"></span>
                    </button>
                }>

                <>
                    {
                        views.map(v =>
                            <li key={v.id} role="menuitem" className={(v.id == view) ? "current" : ""}>
                                <a onClick={() => setViewIfEnabled(v.id)}>
                                    {(v.id == view) && <><i className="fas fa-arrow-right"></i>&nbsp;</>}
                                    {v.icon && <i className={v.icon} style={{ marginRight: 5 }} />}
                                    {v.text}
                                </a>
                            </li>
                        )
                    }
                </>

            </DropDownMenu>
        }
    </div>

}
